<template lang="pug">
JeepIcon(v-if="$config.runtime.theme.header.options.fitmentIcon === 'JEEP'")
BroncoIcon(v-else-if="$config.runtime.theme.header.options.fitmentIcon === 'BRONCO'")
TruckIcon(v-else)
</template>

<script>
import TruckIcon from '@/assets/fitmentIcons/truck?inline'
import JeepIcon from '@/assets/fitmentIcons/jeep?inline'
import BroncoIcon from '@/assets/fitmentIcons/bronco?inline'

export default {
    name: 'FitmentIcon',
    components: {
        TruckIcon,
        JeepIcon,
        BroncoIcon,
    },
}
</script>
